import { useQuery } from '@tanstack/react-query';
import { getApiVersionOptions } from 'api/generated/@tanstack/react-query.gen';
export function useVersion() {
  const {
    data
  } = useQuery({
    ...getApiVersionOptions(),
    staleTime: Infinity
  });
  return data?.version;
}